<template>
  <component :is="type">
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: "PlaceholderComponent",
  props: {
    type: {
      type: String,
      default: "div",
    },
  },
};
</script>
